import React from "react";
import CourseStart2 from "./CourseStart2";
import { useNavigate } from "react-router-dom";
import "./courseCards.css";


export interface CourseCardsProps {
  id: string;
  CourseName: string;
  CourseImage: string;
  Color: string;
  CourseColor: string;
  Duration: string;
  disablebtn: boolean;
  ShortDescription: string;
}

const CourseCards: React.FC<CourseCardsProps> = (props: CourseCardsProps) => {
  let navigate = useNavigate();



  const getCourseListDetails = (courseName: string) => {
    const slug = courseName.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");
    navigate("/coursedetails/" + slug);
  };


  return (
    <div className=" py-6 text-sm border rounded-lg justify-center items-center bg-white shadow-md">
      <div className="flex flex-col justify-center items-center">
        <div className="card-body text-center " style={{ height: "100%" }}>
          <div className="w-full px-4 py-2">
            {/* <img
              className=" items-center w-[100%] object-contain"
              src={props.CourseImage}
              onClick={() => {
                getCourseListDetails(props.CourseName);
              }}
              alt="course logo"
            ></img> */}

            <img
              className=" items-center w-[100%] rounded-[15px] h-[230px]"
              src={props.CourseImage}
              onClick={() => {
                getCourseListDetails(props.CourseName);
              }}
              alt="course logo"
            ></img>
          </div>
          <div
            className="mt-2"
            style={{ marginLeft: "30px", marginRight: "30px" }}
          >
            <h4 className="text-left font-semibold">{props.CourseName}</h4>
            <div className={props.Color}></div>
          </div>
          <div className="px-4">
            <p className="text-[10px] text-left lowercase">{props.Duration}</p>
            <p
              className="text-base text-justify lg:h-[160px]  h-[200px]"
            >
              {props.ShortDescription?.length > 200
            ? `${props.ShortDescription.slice(0, 200)}...`
            : props.ShortDescription}
            </p>
            <p className="text-sm text-left">
              Certificates are awarded at the end of the program.
            </p>
          </div>

          {props.disablebtn === true ? (
            <div className="flex justify-center items-center">
              <div className="disablebtn" style={{ cursor: "pointer" }}>
                <CourseStart2 />
              </div>
            </div>
          ) : (
            <div className="flex justify-start items-center px-4 py-2">
              <div
                className="border-2 text-xl rounded-lg border-[#047E35] p-2 text-[#047E35] hover:bg-[#047E35] hover:text-white cursor-pointer"
                onClick={() => {
                  getCourseListDetails(props.CourseName);
                }}
                style={{ cursor: "pointer" }}
              >
                Learn More
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CourseCards;
